module.exports = __webpack_public_path__ + "static/media/warranty2_top.d7915b28.png";